import { PhoneForwarded, BadgeCheck, CarFront } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { useLang } from "../../lib/i18n";

const STEP_ICONS = [PhoneForwarded, BadgeCheck, CarFront];

export const HowItWorks = () => {
    const { t } = useLang();
    return (
    <section id="hoe-het-werkt" data-testid="how-section" className="relative py-24 sm:py-32">
        <div className="container-x">
            <SectionHeading
                num="05"
                eyebrow={t.how.eyebrow}
                title={t.how.title}
            />
            <div className="relative mt-16 grid gap-10 md:grid-cols-3 md:gap-6">
                <div aria-hidden="true" className="absolute left-0 right-0 top-8 hidden h-px bg-gradient-to-r from-transparent via-amber-400/30 to-transparent md:block" />
                {t.how.steps.map((step, i) => {
                    const Icon = STEP_ICONS[i];
                    const num = `0${i + 1}`;
                    return (
                    <Reveal key={num} delay={0.1 * i}>
                        <div data-testid={`how-step-${i}`} className="relative">
                            <div className="flex items-center gap-5">
                                <span className="relative z-10 flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl border border-amber-400/30 bg-night-900 text-amber-400">
                                    <Icon size={26} />
                                </span>
                                <span className="font-mono text-5xl font-bold text-white/8">{num}</span>
                            </div>
                            <h3 className="mt-6 font-display font-wide text-xl font-bold uppercase text-white sm:text-2xl">
                                {step.title}
                            </h3>
                            <p className="mt-3 max-w-xs text-sm leading-relaxed text-slate-400">{step.text}</p>
                        </div>
                    </Reveal>
                    );
                })}
            </div>
        </div>
    </section>
    );
};
